import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group row" }
const _hoisted_2 = { class: "col-lg-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Nombre", -1)
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Abrev", -1)
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = { class: "col-lg-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Tipo", -1)
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Slug", -1)
const _hoisted_11 = { class: "col-lg-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "TagForm", -1)
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill fs-4 text-danger" }, null, -1)
const _hoisted_16 = { class: "col-sm-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Estado", -1)
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.gblDialog,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.gblDialog) = $event)),
    class: "bg-light",
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    top: "2vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-danger btn-sm text-hover-white me-2",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gblDialog = false))
        }, " Cancelar "),
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.loader,
          class: "btn btn-primary btn-sm",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.gblAction=='new' ? 'Registrar' : 'Actualizar'), 1)
        ], 8, _hoisted_19)
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref: "ruleFormRef",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        class: "form form-label-right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_el_form_item, { prop: "name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_form_item, { prop: "acronym" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.acronym,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.acronym) = $event)),
                    maxlength: "4"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_form_item, { prop: "categorie" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.categorie,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.categorie) = $event)),
                    clearable: "",
                    placeholder: "Seleccionar",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCategorie, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.iddetails,
                          label: item.name,
                          value: item.iddetails
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_form_item, { prop: "slug" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.slug,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.slug) = $event)),
                    maxlength: "30"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_form_item, { prop: "tagform" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.tagform,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.tagform) = $event)),
                    maxlength: "30"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", null, [
                _createTextVNode("Nominal competencia "),
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: "Ficha Nominal de competencia (FNC)",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, { prop: "fnc" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.form.fnc,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.fnc) = $event)),
                    size: "large",
                    "active-text": "SI",
                    "inactive-text": "NO"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_el_form_item, { prop: "mstatus" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.mstatus,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.mstatus) = $event)),
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `s-${item.iddetails}`,
                          label: item.name,
                          value: item.iddetails
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, _ctx.loader]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onOpened", "onClosed"]))
}